import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { InterviewScene } from "./InterviewScene";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.Collage;
        this.mainScene = MainScene;
        this.gameIntroScene = InterviewScene as any;
        this.gameObjectiveTextKey = "Collage.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Collage.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "Collage.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/CollageGame/scenes/IntroductionScene.ts